import { mapState } from 'vuex'
import global from '@/util/mixin/global'
import Info from '../partial/info'
import Push from '../partial/push'

export default {
  mixins:[global],
  methods: {
    handleMoreActions(type, data) {
      let handle = `${type}`
      if (this[handle]) {
        this[handle].call(this, data)
      }
    },

    reboot(data){
      let params = {carNo: data.carNo , code:'RESET'}
      this.$ui.confirm(this.$request.deviceCmdByCode, `确定重启 ${data.carNo} ？`)(params).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.__update()
        } else {
          this.$Notice.error({
            title: '发生错误',
            desc: resp.msg,
          });
        }
      })
    },
    
    enable(data) {
      let tip = data.enableState == 1 ? '禁用' : '启用'
      let params = { carNo: data.carNo, enableState: data.enableState == 1 ? 2 : 1 }
      this.$ui.confirm(this.$request(this.api.enable), `确定${tip} ${data.carNo} ？`)(params).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.__update()
        } else {
          this.$Notice.error({
            title: '发生错误',
            desc: resp.msg,
          });
        }
      })
    },

    turn(data) {
      let tip = data.startState == 1 ? '停止' : '启动'
      let params = { carNo: data.carNo, startState: data.startState == 1 ? 0 : 1 }
      this.$ui.confirm(this.$request(this.api.turn), `确定${tip} ${data.carNo} ？`)(params).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.__update()
        } else {
          this.$Notice.error({
            title: '发生错误',
            desc: resp.msg,
          });
        }
      })
    },

    lock(data){
      let tip = data.lockState == 0 ? '锁定' : '解锁'
      let params = { carNo: data.carNo, lockState: data.lockState == 0 ? 1 : 0 }
      this.$ui.confirm(this.$request(this.api.lock), `确定${tip} ${data.carNo} ？`)(params).then(resp => {
        if (resp.code == 0) {
          this.$Message.success('操作成功')
          this.__update()
        } else {
          this.$Notice.error({
            title: '发生错误',
            desc: resp.msg,
          });
        }
      })
    },

    remove(data) {
      this.$ui.confirm(this.$request(this.api.remove), `确定删除 ${data.carNo} ？`)(data.carNo).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.selection = []
          this.__update()
        } else {
          this.$Notice.error({
            title: '删除发生错误',
            desc: resp.msg,
          });
        }
      })
    },

    review(data){
      this.$dialog({
        title: '车辆变更详情',
        fullscreen:true,
        paddingless: true,
        render: (h) => {
          return <Info reviewable={true} car-no={data.carNo} />
        },
        onOk:({data})=>{
          if(data) this.search()
        }
      })
    },
    transfer(data){
      let options = data.map(i => ({id:i.id , carNo:i.carNo , companyName:i['company.companyName'],license:i['license.licenseNo']}))
      this.$dialog({
        title: '车辆转移',
        // fullscreen:true,
        width:'800px',
        paddingless: true,
        render: (h) => {
          return <Push data={options} />
        },
        onOk:({data})=>{
          if(data) this.search()
        }
      })
    },
    cmd(data){
      
    },

    __update() {
      if (this.list) this.list()
      if (this.query) this.query()
    }
  }
}
